

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.a7eb47f4.js","_app/immutable/chunks/scheduler.26069417.js","_app/immutable/chunks/index.d94cada7.js","_app/immutable/chunks/singletons.aca99d89.js","_app/immutable/chunks/index.1b0f0f41.js"];
export const stylesheets = [];
export const fonts = [];
